<section class="iq-pricing-section">
    <div class="container">
        <div class="spinner-container"  *ngIf="isLoading">
            <mat-spinner *ngIf="isLoading" diameter="100" color="accent"></mat-spinner>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <app-title-section [titleSectionProp]="titleSectionProp"></app-title-section>
            </div>
        </div>
        <div class="yearly-sub-container">
            <mat-button-toggle-group name="planType" aria-label="Plan Type">
                <mat-button-toggle value="monthly" (change)="onMonthlyPlanTypeChange($event)" [checked]="!isYearly">{{"MONTHLY" | translate}}</mat-button-toggle>
                <mat-button-toggle value="yearly" (change)="onYearlyPlanTypeChange($event)" [checked]="isYearly">{{"YEARLY" | translate}}</mat-button-toggle>
            </mat-button-toggle-group>  
        </div>
        <div class="yearly-sub-container" *ngIf="isYearly">
            <div class="offer-container">
                <i class="fa fa-tag" aria-hidden="true"></i>
                <p class="offer-value">25%</p>
                <p class="offer-text">{{"ECONOMY" | translate}}</p>
            </div>
        </div>

        <div class="row">
            <div *ngFor="let item of appPrice.type" class="col-lg-4 col-md-6 col-sm-12 iq-price-container iq-price-table-6 text-center iq-box-shadow wow fadeInUp {{ item.active !== undefined && item.active ? 'active' : '' }}" >
                <div class="iq-price-header" [ngStyle]="{'min-height': isYearly ? '347px' : '309px'}">
                    <span class="iq-price-label">{{item.typeName | translate}}</span>
                    <h4 class="iq-price" *ngIf="!isYearly || item.typeName=='FREE'&& isYearly">{{item.priceValue}} {{item.price | translate}}<span class="iq-price-desc">{{item.plan_desc | translate}}</span></h4>
                    <span class="iq-price-old" *ngIf="isYearly && item.typeName!=='FREE'">{{item.fullPriceYearly}} {{item.priceYearly | translate}}</span>
                    <h4 class="iq-price" *ngIf="isYearly && item.typeName!=='FREE'">{{item.sparedPriceYearly}} {{item.priceYearly | translate}}</h4>
                    <div class="offer-container" *ngIf="isYearly && item.typeName!=='FREE'">
                        <p class="offer-text" style="margin-right: 3px;">{{"YOU_SAVE" | translate}}</p>
                        <p class="offer-value">{{item.fullPriceYearly - item.sparedPriceYearly}} €</p>
                        
                    </div>
                    <p class="iq-price-description">{{item.description | translate}}</p>
                    
                    <ul class="iq-db-service" *ngIf="item.dbOptions">
                        <li class="nav-item" >
                            <a class="nav-link dropdown-toggle">
                                {{item.currentDb}}
                                <i class="fa fa-angle-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item" *ngFor="let db of item.dbOptions">
                                    <a class="nav-link" (click)="changeDb(item,db)">
                                        {{db}}
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>

                </div>
                <div class="iq-price-body">
                    <ul class="iq-price-service">
                        <li *ngFor="let service of item.additionalInfo"  class="{{ service.active !== undefined && service.active ? 'active' : 'inactive' }}">
                            <span class="service-info-text"> 
                                <i class="fa fa-light fa-plus mr-2" *ngIf="service.title=='PRICING_ADDITIONAL'"></i> 
                                <i class="fa fa-light fa-check mr-2" *ngIf="service.title!=='PRICING_ADDITIONAL'"></i>
                                <span [ngClass]="service.style ? [service.style] : []">{{ service.title | translate }}</span>
                            </span>
                            <i aria-hidden="true" class=""></i>
                        </li>
                    </ul>
                    <ul class="combobox-container" *ngIf="item.comboboxInfo">
                        <li class="combobox" *ngFor="let combobox of item.comboboxInfo">
                            <span class="service-text">{{ combobox.title | translate }}</span>
                            <div class="counter">
                                <button class="counter-btn" (click)="decrease(combobox, item)">-</button>
                                <input class="combobox-number" type="number" [value]="combobox.value" [step]="combobox.step || 1" [min]="combobox.minValue" [max]="combobox.maxValue" (change)="onInputChange($event, combobox, item)">
                                <button class="counter-btn" (click)="increase(combobox, item)">+</button>
                            </div>
                            <div class="warning" *ngIf="combobox.title=='GB_DISK_SPACE' && combobox.value>combobox.maxValue">
                                <p>{{"MAX_SSD_WARNING" | translate}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="iq-price-footer">
                    <div class="iq-btn-container" *ngIf="item.downloadOrPay =='PAY'">
                        <a class="iq-button iq-btn-round d-inline" [ngClass]="{'disabled': !canOrderFree.value && item.typeName == 'FREE'}" (click)="payForProduct(item)" [disabled]="!canOrderFree.value && item.typeName == 'FREE'">{{item.downloadOrPay | translate}}</a>
                    </div>
                    <div class="iq-btn-container" *ngIf="item.downloadOrPay =='DOWNLOAD'">
                        <a class="iq-button iq-btn-round d-inline" (click)="redirectDownload(item)">{{item.downloadOrPay | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
